import { gql } from '@apollo/client';

export default gql`
  query planProducts {
    planProducts {
      id
      name
    }
  }
`;
